export const instruments = {
  "0": "Acoustic Grand Piano",
  "1": "Bright Acoustic Piano",
  "2": "Electric Grand Piano",
  "3": "Honky-tonk Piano",
  "4": "Electric Piano 1",
  "5": "Electric Piano 2",
  "6": "Harpsichord",
  "7": "Clavinet",

  "8": "Celesta",
  "9": "Glockenspiel",
  "10": "Music Box",
  "11": "Vibraphone",
  "12": "Marimba",
  "13": "Xylophone",
  "14": "Tubular Bells",
  "15": "Dulcimer",

  "16": "Drawbar Organ",
  "17": "Percussive Organ",
  "18": "Rock Organ",
  "19": "Church Organ",
  "20": "Reed Organ",
  "21": "Accordion",
  "22": "Harmonica",
  "23": "Tango Accordion",

  "24": "Acoustic Guitar (nylon)",
  "25": "Acoustic Guitar (steel)",
  "26": "Electric Guitar (jazz)",
  "27": "Electric Guitar (clean)",
  "28": "Electric Guitar (muted)",
  "29": "Overdriven Guitar",
  "30": "Distortion Guitar",
  "31": "Guitar Harmonics",

  "32": "Acoustic Bass",
  "33": "Electric Bass (finger)",
  "34": "Electric Bass (pick)",
  "35": "Fretless Bass",
  "36": "Slap Bass 1",
  "37": "Slap Bass 2",
  "38": "Synth Bass 1",
  "39": "Synth Bass 2",

  "40": "Violin",
  "41": "Viola",
  "42": "Cello",
  "43": "Contrabass",
  "44": "Tremolo Strings",
  "45": "Pizzicato Strings",
  "46": "Orchestral Harp",
  "47": "Timpani",

  "48": "String Ensemble 1",
  "49": "String Ensemble 2",
  "50": "Synth Strings 1",
  "51": "Synth Strings 2",
  "52": "Choir Aahs",
  "53": "Voice Oohs",
  "54": "Synth Voice",
  "55": "Orchestra Hit",

  "56": "Trumpet",
  "57": "Trombone",
  "58": "Tuba",
  "59": "Muted Trumpet",
  "60": "French Horn",
  "61": "Brass Section",
  "62": "Synth Brass 1",
  "63": "Synth Brass 2",

  "64": "Soprano Sax",
  "65": "Alto Sax",
  "66": "Tenor Sax",
  "67": "Baritone Sax",
  "68": "Oboe",
  "69": "English Horn",
  "70": "Bassoon",
  "71": "Clarinet",

  "72": "Piccolo",
  "73": "Flute",
  "74": "Recorder",
  "75": "Pan Flute",
  "76": "Blown Bottle",
  "77": "Shakuhachi",
  "78": "Whistle",
  "79": "Ocarina",

  "80": "Lead 1 (square)",
  "81": "Lead 2 (sawtooth)",
  "82": "Lead 3 (calliope)",
  "83": "Lead 4 (chiff)",
  "84": "Lead 5 (charang)",
  "85": "Lead 6 (voice)",
  "86": "Lead 7 (fifths)",
  "87": "Lead 8 (bass + lead)",

  "88": "Pad 1 (new age)",
  "89": "Pad 2 (warm)",
  "90": "Pad 3 (polysynth)",
  "91": "Pad 4 (choir)",
  "92": "Pad 5 (bowed)",
  "93": "Pad 6 (metallic)",
  "94": "Pad 7 (halo)",
  "95": "Pad 8 (sweep)",

  "96": "FX 1 (rain)",
  "97": "FX 2 (soundtrack)",
  "98": "FX 3 (crystal)",
  "99": "FX 4 (atmosphere)",
  "100": "FX 5 (brightness)",
  "101": "FX 6 (goblins)",
  "102": "FX 7 (echoes)",
  "103": "FX 8 (sci-fi)",

  "104": "Sitar",
  "105": "Banjo",
  "106": "Shamisen",
  "107": "Koto",
  "108": "Kalimba",
  "109": "Bagpipe",
  "110": "Fiddle",
  "111": "Shanai",

  "112": "Tinkle Bell",
  "113": "Agogo",
  "114": "Steel Drums",
  "115": "Woodblock",
  "116": "Taiko Drum",
  "117": "Melodic Tom",
  "118": "Synth Drum",
  "119": "Reverse Cymbal",

  "120": "Guitar Fret Noise",
  "121": "Breath Noise",
  "122": "Seashore",
  "123": "Bird Tweet",
  "124": "Telephone Ring",
  "125": "Helicopter",
  "126": "Applause",
  "127": "Gunshot"
};
/* export const instruments = [
 "Acoustic Grand Piano",
 "Bright Acoustic Piano",
 "Electric Grand Piano",
 "Honky tonk Piano",
 "Electric Piano 1",
 "Electric Piano 2",
 "Harpsichord",
 "Clavi",
 "Celesta",
 "Glockenspiel",
 "Music Box",
 "Vibraphone",
 "Marimba",
 "Xylophone",
 "Tubular Bells",
 "Dulcimer",
 "Drawbar Organ",
 "Percussive Organ",
 "Rock Organ",
 "Church Organ",
 "Reed Organ",
 "Accordion",
 "Harmonica",
 "Tango Accordion",
 "Acoustic Guitar nylon",
 "Acoustic Guitar steel",
 "Electric Guitar jazz",
 "Electric Guitar clean",
 "Electric Guitar muted",
 "Overdriven Guitar",
 "Distortion Guitar",
 "Guitar Harmonics",
 "Acoustic Bass",
 "Electric Bass finger",
 "Electric Bass pick",
 "Fretless Bass",
 "Slap Bass 1",
 "Slap Bass 2",
 "Synth Bass 1",
 "Synth Bass 2",
 "Violin",
 "Viola",
 "Cello",
 "Contrabass",
 "Tremolo Strings",
 "Pizzicato Strings",
 "Orchestral Harp",
 "Timpani",
 "String Ensemble 1",
 "String Ensemble 2",
 "Synth Strings 1",
 "Synth Strings 2",
 "Choir Aahs",
 "Voice Oohs",
 "Synth Voice",
 "Orchestra Hit",
 "Trumpet",
 "Trombone",
 "Tuba",
 "Muted Trumpet",
 "French Horn",
 "Brass Section",
 "Synth Brass 1",
 "Synth Brass 2",
 "Soprano Sax",
 "Alto Sax",
 "Tenor Sax",
 "Baritone Sax",
 "Oboe",
 "English Horn",
 "Bassoon",
 "Clarinet",
 "Piccolo",
 "Flute",
 "Recorder",
 "Pan Flute",
 "Blown Bottle",
 "Shakuhachi",
 "Whistle",
 "Ocarina",
 "Lead 1 square",
 "Lead 2 sawtooth",
 "Lead 3 calliope",
 "Lead 4 chiff",
 "Lead 5 charang",
 "Lead 6 voice",
 "Lead 7 fifths",
 "Lead 8 bass lead",
 "Pad 1 new age",
 "Pad 2 warm",
 "Pad 3 polysynth",
 "Pad 4 choir",
 "Pad 5 bowed",
 "Pad 6 metallic",
 "Pad 7 halo",
 "Pad 8 sweep",
 "FX 1 rain",
 "FX 2 soundtrack",
 "FX 3 crystal",
 "FX 4 atmosphere",
 "FX 5 brightness",
 "FX 6 goblins",
 "FX 7 echoes",
 "FX 8 sci fi",
 "Sitar",
 "Banjo",
 "Shamisen",
 "Koto",
 "Kalimba",
 "Bagpipe",
 "Fiddle",
 "Shanai",
 "Tinkle Bell",
 "Agogo",
 "Steel Drums",
 "Woodblock",
 "Taiko Drum",
 "Melodic Tom",
 "Synth Drum",
 "Reverse Cymbal",
 "Guitar Fret Noise",
 "Breath Noise",
 "Seashore",
 "Bird Tweet",
 "Telephone Ring",
 "Helicopter",
 "Applause",
 "Gunshot"
]; */